import {useLocation} from "react-router-dom";
import React, {useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../utils/EditLocalStoragePagesData";
import Box from "@mui/material/Box";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import selectionTableUtil, {normalizeSelection} from "../../utils/common/SelectionTableUtil";

const ExportTable = ({data, selectedString, setSelectedString, rowSelection, setRowSelection}) => {
    const pathname = useLocation().pathname
    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: data.length,
        searchData: ""
    })

    const tableOptionsHandle = (nextState) => {
        const itemId = 0
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'position',
                header: 'Позиция',
                accessorKey: "position",
                size: 300,
                grow: true,
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorKey: 'name',
                minSize: 60,
            },
            {
                id: 'length',
                header: 'W',
                accessorKey: 'length',
                minSize: 15,
                maxSize: 15,
            },
            {
                id: 'width',
                header: 'H',
                accessorKey: 'width',
                minSize: 15,
                maxSize: 15,
            },
            {
                id: 'quantity',
                header: 'кол.',
                accessorKey: 'quantity',
                minSize: 15,
                maxSize: 15,
                enableColumnActions: false,
            },
        ]

        return baseColumns;

    }, [data]);

    return (<Box sx={{width: "900px", overflow: 'auto',}}>
        <MaterialReactTable
            renderTopToolbar={({table}) => {
                return <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "7px",
                    backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                }}>
                    <MRT_ToolbarAlertBanner table={table}/>
                    <Box sx={{display: "flex"}}>
                        <MRT_ToggleFiltersButton table={table}/>
                        <MRT_GlobalFilterTextField table={table}/>
                    </Box>
                </Box>
            }}

            muiToolbarAlertBannerProps={{
                sx: {
                    backgroundColor: (theme) => theme.palette.primary.light,
                    "& .MuiStack-root": {
                        padding: 0,
                    },
                }
            }}

            muiTableContainerProps={{
                sx: {
                    width: '900px',
                    maxHeight: `calc(100vh - 590px)`
                }
            }}
            muiTableBodyCellProps={({cell}) => {
                const isSelected = cell.row.id === selectedString.id;

                const borderStyle = isSelected ? "2px solid #3B8BEC" : "2px solid transparent";

                return {
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        overflow: "hidden", maxWidth: cell.column.columnDef.maxSize,
                        whiteSpace: "nowrap", textOverflow: "ellipsis",
                        borderTop: borderStyle,
                        borderBottom: borderStyle,
                        " :first-of-type": {
                            borderTop: borderStyle,
                            borderLeft: borderStyle,
                            borderBottom: borderStyle,
                        },
                        ":last-child": {
                            borderTop: borderStyle,
                            borderRight: borderStyle,
                            borderBottom: borderStyle,
                        }
                    },
                }
            }
            }
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem",
                    "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                        "minWidth": "100%"
                    }
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    onClick: () => setSelectedString(row.original),
                    sx: () => ({
                        height: '36px',
                        cursor: "pointer",
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        '&:nth-of-type(even)': {
                            backgroundColor: '#F5F6FA',
                        },
                    })
                })
            }}

            displayColumnDefOptions={{
                'mrt-row-select': {
                    size: "50px",
                    grow: false,
                },
            }}
            muiSearchTextFieldProps={{
                placeholder: `Поиск`,
                sx: {
                    paddingTop: "5px",
                    paddingBottom: "0px",
                    "& .MuiCollapse-root": {
                        borderRadius: '12px',
                        height: 40, width: 290,
                        "& .MuiSvgIcon-root": {
                            color: "#737478"
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: 0
                        }
                    }
                },
                variant: 'outlined',
            }}
            columns={columns}
            data={data}
            rowHeight={13}
            columnSpacing={1}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            onPaginationChange={(updater) => {
                tableOptionsHandle(updater(tableOptions));
            }}
            enableRowSelection={true}
            onRowSelectionChange={onRowSelectionChange}
            state={{rowSelection: currentSelection, showGlobalFilter: true, pagination: tableOptions,}}
            rowCount={tableOptions.totalElements}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}
            localization={MRT_Localization_RU}
            enableRowActions={false}
            enableToolbarInternalActions={false}
        />
    </Box>);
};

export default ExportTable;